module.exports = __webpack_public_path__ + "img/serviceState8.d3eca42c.svg";